import { useIntl } from "react-intl";
import { CommandBarButton, Stack } from "@fluentui/react";
import { ExportFileHandler } from "@cayo/shared";
import { ExportConfig } from "@cayo/shared/api/types/schema";
import { exportDropdownStyles } from "./ExportButton.styles";
import { getExportIconName } from "./utils/getExportIconName";
import { commandBarMessages } from "../../../CommandBar/messages";
import { useQuickFilterBarButtonStyle } from "../../GridFilterBar.style";

type ExportButtonProps = {
  exportConfig: ExportConfig;
  disabled?: boolean;
  onExport: ExportFileHandler;
};

export const ExportButton = ({ exportConfig, onExport, disabled }: ExportButtonProps) => {
  const { formats, defaultFormat } = exportConfig;
  const mainFormat = defaultFormat ?? "csv";
  const exportButtonStyles = useQuickFilterBarButtonStyle();
  const intl = useIntl();

  return (
    <Stack styles={{ root: { flexGrow: 1, width: "100%" } }}>
      <CommandBarButton
        split
        iconProps={{ iconName: getExportIconName(mainFormat) }}
        title={intl.formatMessage(commandBarMessages.exportTo, {
          format: mainFormat.toUpperCase(),
        })}
        ariaLabel={intl.formatMessage(commandBarMessages.exportButton)}
        splitButtonAriaLabel={intl.formatMessage(commandBarMessages.seeOptions)}
        styles={exportButtonStyles}
        menuProps={{
          items: formats.map((format) => ({
            key: format,
            text: intl.formatMessage(commandBarMessages.exportTo, {
              format: format.toUpperCase(),
            }),
            onClick: () => onExport(format),
            disabled: disabled,
            iconProps: { iconName: getExportIconName(format) },
          })),
          styles: exportDropdownStyles,
        }}
        onClick={() => onExport(mainFormat)}
        disabled={disabled}
      >
        {intl.formatMessage(commandBarMessages.exportTo, {
          format: mainFormat.toUpperCase(),
        })}
      </CommandBarButton>
    </Stack>
  );
};
